import {
    Slider,
    SliderTrack,
    SliderFilledTrack,
    SliderThumb,
    SliderMark,
    Tooltip
} from '@chakra-ui/react'
import {useEffect, useState} from "react";
import React from "react"
import ThreeDViewComponent from "../Components/ThreeDViewer";
import loadCorrDates from "../services/viewerFuncs/getDates";
import {useAuthState} from "../Context";
//let availDates, renderedDate


function DateSlider(props) {
    console.log(`dateslider props: ${JSON.stringify(props)}`)
    const userDetails = useAuthState()
    const [sliderValue, setSliderValue] = useState(0)
    const [showTooltip, setShowTooltip] = useState(false)
    const [dataset, setDataset] = useState('')
    const [availDates, setAvailDates] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const setComps = (sliderVal) => {
        setSliderValue(sliderVal)
        window.history.pushState("", "", `/3DViewer/${props.dataset}/${sliderVal}/1`);
        ThreeDViewComponent(props.dataset, false, sliderVal, undefined, '1', userDetails.token)
    }


    const fetchDates = (corridor) =>{
        loadCorrDates(corridor)
            .then((response) =>{
                setIsLoading(false)
                setAvailDates(response)
            })
            .catch((error) =>{
                setIsLoading(false)
                setIsError(true)
            })
    }

    useEffect(() => {
        if (props.dataset !== undefined){
            fetchDates(props.dataset)
        }

    }, [dataset, props.dataset]);


    useEffect(() => {
        if (availDates !== undefined){
            setSliderValue(availDates[0])
        }
    }, [availDates]);

    if (availDates !== undefined || availDates !== ['']){
    return (

    <Slider
        id='slider'
        defaultValue={0}
        min={0}
        max={availDates.length-1}
        colorScheme='teal'
        onChangeEnd={(v) => setComps(availDates[v])}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
    >
        <>{availDates.map(function (date, i) {
            if(i % 5 === 0 || i === availDates.length-1) {
                return <SliderMark value={i} mt='1' ml='-2.5' fontSize='sm'>
                    {date}
                </SliderMark>
            }
        })}</>
        <SliderTrack>
            <SliderFilledTrack/>
        </SliderTrack>
        <Tooltip
            hasArrow
            bg='teal.500'
            color='white'
            placement='top'
            isOpen={showTooltip}
            label={`${sliderValue}`}
        >
            <SliderThumb/>
        </Tooltip>
    </Slider>
)}
    else {
        return <div></div>
    }
}



export default DateSlider;
